import React from "react";
import { BookOpenCheckIcon, ClipboardListIcon, GiftIcon, HeartPulseIcon, Music2Icon, BoxIcon } from "lucide-react";
type Bonus = {
  icon: BoxIcon;
  title: string;
  value: string;
  description: string;
  imageUrl: string;
};
const bonuses: Bonus[] = [{
  icon: BookOpenCheckIcon,
  title: 'The Transition Bible',
  value: '$25 Value',
  description: 'Create smoother, more confident sequences with clear transition ideas that keep every class moving naturally.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/6juLNhk5Hk9N3iEZLMf8Q1/a471318d-a6f9-47d9-907e-a99215164f98-mockup.webp'
}, {
  icon: ClipboardListIcon,
  title: 'The Cueing Dictionary',
  value: '$15 Value',
  description: 'Find the words that make your instructions easier to understand, feel, and apply in every movement.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/enhHPSY41pJRg1oJo2Z78u/6a231977-4f94-4a66-a611-f7257b76cf1b-mockup.webp'
}, {
  icon: HeartPulseIcon,
  title: 'Modifying for Injuries',
  value: '$20 Value',
  description: 'Teach with greater confidence using practical modification options for common injuries and limitations.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/dmLu9MGnQuSS9gNZpGBfr8/7899fe3e-1696-4e8a-9696-541f802674ca-mockup.webp'
}, {
  icon: Music2Icon,
  title: 'Class Playlist Curations',
  value: '$12 Value',
  description: 'Set the right atmosphere with curated playlists designed for focused, energetic, and restorative classes.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/xqZUTeEtmjHwfZzLggHo7g/135b0302-0ea5-4f0b-ad2f-1267c82a84eb-mockup.webp'
}, {
  icon: GiftIcon,
  title: 'The Business of Pilates',
  value: '$15 Value',
  description: 'Support the business behind your teaching with practical guidance for a stronger, more sustainable studio.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/vbMKKMAccSn8LeDZmsw4aZ/800fb7ec-4499-4aa9-a347-718fa42db9db-mockup.webp'
}];
export function BonusSection() {
  return <section className="bg-[#241622] px-5 py-20" data-id="element-3" data-mp="3h7ramk6pkb4e">
      <div className="mx-auto max-w-5xl" data-id="element-4" data-mp="1h2lzz0gjj5tb">
        <div className="text-center" data-id="element-5" data-mp="1h5i1eyrlkcmi">
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-emerald-300" data-id="element-6" data-mp="1c4tz3gxx49cz">
            <GiftIcon className="h-4 w-4" data-id="element-7" data-mp="1q322o7pgm8x4" /> Included free today
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-8" data-mp="1m1yorqqz2myj">
            Five strategic <span className="text-emerald-300" data-id="element-9" data-mp="ydyw2la3omhb">bonuses</span>
          </h2>
          <p className="mt-4 text-sm font-medium text-slate-300" data-id="element-10" data-mp="teckeg9x7eam">
            Real bonus-pack value: $87 — included free today with PILATES READY™.
          </p>
        </div>

        <div className="mt-11 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-11" data-mp="12eivxwm26475">
          {bonuses.map(({
          icon: Icon,
          title,
          value,
          description,
          imageUrl
        }, index) => <article key={title} className="overflow-hidden border border-emerald-200/20 bg-[#38233c]" data-id="element-12" data-mp="anl40urimnmq" data-mpi={index}>
              <img src={imageUrl} alt={`Mockup of the ${title} bonus`} width={1024} height={1024} loading="lazy" className="aspect-square w-full object-cover" data-id="element-13" data-mp="jo7nmjc42z2" />
              <div className="p-6" data-id="element-14" data-mp="5bfsrhjq1ght">
                <div className="flex items-center justify-between gap-4" data-id="element-15" data-mp="3mquvmgyaulus">
                  <span className="grid h-11 w-11 place-items-center border border-emerald-300/40 bg-emerald-400/10" data-id="element-16" data-mp="3mortwznsb4a8">
                    <Icon className="h-5 w-5 text-emerald-300" data-id="element-17" data-mp="ja5mqob8v01y" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-18" data-mp="o8z08gqj6r24">
                    Bonus {String(index + 1).padStart(2, '0')}
                  </p>
                </div>
                <div className="mt-6" data-id="element-19" data-mp="easyq08mzmxs">
                  <span className="border border-emerald-300/40 px-2 py-1 text-[10px] font-bold uppercase text-emerald-200" data-id="element-20" data-mp="e9rr65qtxikt">
                    {value} — Free today
                  </span>
                  <h3 className="mt-4 text-lg font-bold text-white" data-id="element-21" data-mp="2z1a7zkr7b0f6">{title}</h3>
                  <p className="mt-2 text-sm font-medium leading-relaxed text-slate-300" data-id="element-22" data-mp="3f7wrlljy5off">{description}</p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}